import {
    Container,
  } from "@mui/material";
  
import HeroSection from "./HeroSection";
import OurServices from "./OurServices";
import HowItWorks from "./HowItWorks";
import YeloDifference from "./YeloDifference";
import FAQs from "./FAQs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
  
  const Events = () => {
    const { i18n } = useTranslation("");
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      if (i18n.language === "ar" || pathname.includes("/ar")) {
        navigate("/الأحداث");
      }
      else {
        navigate("/events");
      }
    }, [i18n.language, navigate, pathname]);
  
    return (
      <>
       <Container sx={{ mt: 5 }}>
        <HeroSection />
        <OurServices />
        <HowItWorks />
        <YeloDifference/>
        <FAQs /> 
      </Container>
      </>
    );
  };
  
  export default Events;
 
